import { ContentService } from '@blk/cwp-ng-framework';
import { TabData } from '@ddt-web/data-service';

export class EsgCoverageUtil {
	public static generateCoverageText(data: TabData, contentService: ContentService): string {
		const tableData = data?.tableData[0];
		const portfolioNames = tableData?.headersX;
		const coverageDetails = tableData?.cells[0];
		const formattedTexts = [];
		const separatorText = contentService.get('ESG_COVERAGE_SEPARATOR_TEXT', ': ');
		portfolioNames?.forEach((cellData, index) => {
			formattedTexts.push(cellData?.formattedValue + separatorText + coverageDetails[index]?.formattedValue);
		});
		return formattedTexts.join(', ');
	}
}
